


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CreateNews from '@components/Settings/News/CreateNews.vue';
import Toast from '@common/helpers/toast';
import ApiHelper from 'api-helper';
import Loading from '@/components/common/PageLoader.vue';
import LeaveConfirm from '@components/Settings/News/LeaveConfirm.vue';
import { AuthenticationModule } from '@/store';
import LocalStorageUtils from '@common/LocalStorageUtils';
import { mapState } from 'vuex';
import { DashboardModule } from '@/store';

const PostDetail = Vue.extend({
  data() {
    return {
      isChangeData: false,
      isLoading: false,
    };
  },

  created() {
    window.onbeforeunload = this.reloadHandler;
  },

  beforeDestroy() {
    window.onbeforeunload = null;
  },

  components: {
    CreateNews,
    LeaveConfirm,
    Loading,
  },

  computed: {
    ...mapState('auth', ['currentUser']),
  },

  methods: {
    async logout() {
      try {
        (window as any).UA.then(async (sdk: any) => {
          if (!sdk.channel.namedUser) {
            return;
          }
          await sdk.channel.namedUser.remove(`managers_${this.currentUser.id}`);
          await sdk.register();
        });
        await AuthenticationModule.logout();
        await DashboardModule.setClinics([]);
        await LocalStorageUtils.removeItem('dashboardID');
        await LocalStorageUtils.removeItem('revenueClinic');
        await LocalStorageUtils.removeItem('monthlyReportClinic');
        await localStorage.removeItem('isLoggedIn');
      } catch (error) {
        Toast.error(error.response.data.message);
      }
    },

    leaveConfirm(next, isSignout = false) {
      let options = {
        onOK: () => {
          next();
        },
      };
      if (isSignout) {
        options = {
          onOK: async () => {
            await this.logout();
            next();
          },
        };
      }
      this.$modal.show('leave-confirm', options);
    },

    reloadHandler(event) {
      if (this.isChangeData) {
        event.preventDefault();
        event.returnValue = '';
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.isChangeData) {
      if (to.name === 'Login') {
        this.leaveConfirm(next, true);
      } else {
        this.leaveConfirm(next);
      }
    } else {
      if (to.name === 'Login') {
        this.logout().then(() => {
          next();
        });
      } else {
        next();
      }
    }
  },
});

export default PostDetail;
